import {BiNetworkChart} from "react-icons/bi";
import UILinkButton from "./UILinkButton";
import React from "react";

/**
 * This button navigates the user to the 'Subnetwork View' page when clicked.
 */
const SubNetworkLinkButton = () => {
  return (
    <UILinkButton to="/subnetwork" title="Subnetwork View" icon=<BiNetworkChart/> />
  );
};
export default SubNetworkLinkButton;